import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import {
  paymentJustificationInitialState,
  PaymentJustificationStateProps,
  paymentJustificationStateStore,
} from './payment-justification-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class PaymentJustificationRepository extends BaseStoreRepository<PaymentJustificationStateProps> {
  constructor() {
    super(paymentJustificationStateStore.pipe(select(state => state)), paymentJustificationStateStore, paymentJustificationInitialState);
  }
}
